module.exports = __webpack_public_path__ + "assets/24b081705de2d3215ddb246ba0640301.png";